module.exports = __webpack_public_path__ + "img/curas2.221ca4a5.jpg";